import { ModelBase, PropertyChangedContext, PropertyChangedJoinPointContext } from '@skylab-shared/core';
import { Constructor } from '@skylab-shared/types';

type Handler = (ctx: PropertyChangedJoinPointContext) => void;

export const propertyChangedJoinPointFilter = (sender: any) => <TModel extends ModelBase>(type: Constructor<TModel>, properties: (keyof TModel)[] | '*') => (handler: Handler): Handler => {
    return (ctx: PropertyChangedJoinPointContext): void => {
        if (ctx.model instanceof type && (sender == null || (sender != null && ctx.sender === sender)) && ((<string[]> properties).indexOf(ctx.propertyName) > -1 || properties === '*')) {
            handler(ctx);
        }
    };
};

export const propertyChangedFilter = <TModel extends ModelBase>(
    type: Constructor<TModel>,
    properties: (keyof TModel)[],
    handler: (ctx: PropertyChangedContext<TModel>) => void
): (ctx: PropertyChangedContext<TModel>) => void => {
    return (ctx: PropertyChangedContext<TModel>) => {
        if (ctx.model instanceof type && (<string[]> properties).indexOf(ctx.propertyName) > -1) {
            handler(ctx);
        }
    };
};
